import { Component } from '@angular/core';

/**
 * Generated class for the ShareIconComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'share-icon',
  templateUrl: 'share-icon.html'
})
export class ShareIconComponent {
  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/components/icons/share-icon/share-icon.ts